<template>
  <div class="news-subscribe">
    <component
      v-if="showNewsSubscribe"
      :is="isModal ? 'ModalWindow' : 'SidebarSection'"
      :title="title"
      popup
      @close="$emit('closeModal')"
    >
      <template v-if="!isSent" #body>
        <BasicForm
          :action="subscribeUser"
          @success="onSubscribe"
          v-slot="{ requestInProcess }"
        >
          <div class="news-subscribe__block">
            <div class="news-subscribe__description">
              {{ description }}
            </div>
              <FormField
                v-if="subscribeInfo.isGuest"
                name="email"
                v-slot="{ invalid }"
              >
                <TextInput
                  v-model="email"
                  class="news-subscribe__input"
                  type="email"
                  name="email"
                  :invalid="invalid"
                  placeholder="Электропочта"
                />
              </FormField>
          </div>
          <BasicButton
            class="news-subscribe__button"
            appearance="primary"
            size="m"
            type="submit"
            :disabled="requestInProcess"
          >
            Подписаться
          </BasicButton>
        </BasicForm>
      </template>
      <template v-else #body>
        <div class="news-subscribe__block">
          <div class="news-subscribe__ready-block">
            <SvgIcon
              icon="check-circle"
              size="24"
            />
            <span>Готово</span>
          </div>
          <div class="news-subscribe__description">
            {{ successDescription }}
          </div>
        </div>
        <BasicButton
          class="news-subscribe__link"
          appearance="link"
          :href="buttonLink"
        >
          {{ buttonTitle }}
        </BasicButton>
      </template>
    </component>
    <ResourceAction
      ref="getSubscribeInfoResource"
      :action="getSubscribeInfoAction"
      :debounce="400"
      @success="onLoadSubscribeInfo"
    />
  </div>
</template>

<script>
  import { GuestService } from 'src/services/guest.js';
  import { SubscribeService } from 'src/services/subscribe.js';
  import { getCookie, setInsecureCookie } from 'src/utils/cookies.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicForm from 'src/components/form/BasicForm/BasicForm.vue';
  import FormField from 'src/components/form/FormField/FormField.vue';
  import TextInput from 'src/components/form/TextInput/TextInput.vue';
  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
  import ModalWindow from 'src/components/overlays/ModalWindow/ModalWindow.vue';
  import ResourceAction from 'src/components/ResourceAction/ResourceAction.vue';
  import SidebarSection from 'src/components/sidebar/SidebarSection/SidebarSection.vue';

  const NEWS_SUBSCRIBE_FLAG = 'has_news_subscribe';
  const NEWS_SUBSCRIBE_BREAK = 24 * 60 * 60; // 1 сутки

  export default {
    name: 'NewsSubscribe',
    components: {
      BasicForm,
      SvgIcon,
      SidebarSection,
      BasicButton,
      TextInput,
      ResourceAction,
      FormField,
      ModalWindow,
    },
    props: {
      showSubscribe: {
        type: Function,
        default: () => true,
      },
      isModal: {
        type: Boolean,
        default: false,
      }
    },
    emits: ['closeModal'],
    data() {
      return {
        email: '',
        userEmail: '',
        isSent: false,
        subscribeInfo: null,
      }
    },
    mounted() {
      const hasSubscribe = getCookie(NEWS_SUBSCRIBE_FLAG);
      if (!hasSubscribe) {
        this.$refs.getSubscribeInfoResource.dispatch();
      }
    },
    methods: {
      subscribeUserAction: SubscribeService.subscribeUser,
      getSubscribeInfoAction: SubscribeService.getSubscribeInfo,
      subscribeGuestAction: GuestService.createSubscription,
      subscribeUser() {
        if (this.subscribeInfo.isGuest) {
          return GuestService.createSubscription({ email: this.email, type: 'news'})
        }
        return SubscribeService.subscribeUser();
      },
      onSubscribe({ email }) {
        this.userEmail = email;
        this.isSent = true;
        if (this.subscribeInfo.isGuest) {
          setInsecureCookie(
            NEWS_SUBSCRIBE_FLAG,
            true,
            {'max-age': NEWS_SUBSCRIBE_BREAK}
          );
        }
      },
      onLoadSubscribeInfo({ data }) {
        this.subscribeInfo = data.subscribeInfo;
      },
    },

    computed: {
      title() {
        return this.subscribeInfo.isHr ? 'Рассылка для HR в IT' : 'Рассылка про карьеру в IT';
      },
      description() {
        return this.subscribeInfo.isHr ? 'Раз в неделю собираем письмо для тех, кто нанимает айтишников.'
          : 'Пишем пару раз в месяц про зарплаты, тренды на рынке и карьерные треки.';
      },
      buttonTitle() {
        return this.subscribeInfo.isGuest ? 'Создать профиль на Хабр Карьере' : 'Управление рассылками';
      },
      successDescription() {
        return `Скоро на ${this.userEmail} придет письмо. Подтвердите подписку, если всё в силе.`;
      },
      buttonLink() {
        return this.subscribeInfo.isGuest
          ? this.subscribeInfo.registerHref
          : this.subscribeInfo.notificationsHref;
      },
      showNewsSubscribe() {
        if (!this.subscribeInfo) return false;
        return this.showSubscribe(this.subscribeInfo);
      },
    }
  }
</script>